import React, { Component } from 'react';
import $ from 'jquery';
import 'moment';
import 'fullcalendar';
import 'fullcalendar/dist/fullcalendar.css';
import moment from 'moment';
import CircularProgress from 'material-ui/CircularProgress';
import autoBind from 'react-autobind';
import RaisedButton from 'material-ui/RaisedButton';

class CalendarSeasonCalculationCalendarModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.calendarRef = React.createRef();
        this.state = {
            startedFetching: false,
        };
    }

    componentDidMount() {
        this.initCalendar();
        this.updateCalendarEvents();
    }

    componentDidUpdate(prevProps) {
        const { calendarSeason } = this.props;
        const prevSeason = prevProps.calendarSeason;
        if ((prevSeason.isFetching && !calendarSeason.isFetching) || prevSeason.items !== calendarSeason.items) {
            this.updateCalendarEvents();
        }
    }

    componentWillUnmount() {
        if (this.calendarRef.current) {
            $(this.calendarRef.current).fullCalendar('destroy');
        }
    }

    initCalendar = () => {
        const { t, i18n } = this.props;
        $(this.calendarRef.current).fullCalendar({
            locale: i18n.language,
            header: {
                left: '',
                center: 'title',
                right: 'prev,next today',
            },
            defaultView: 'month',
            selectable: false,
            editable: false,
            buttonText: {
                today: t('calendar.today'),
                day: t('calendar.day'),
                week: t('calendar.week'),
                month: t('calendar.month'),
                list: t('calendar.list'),
            },
            schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
        });
    };

    updateCalendarEvents = () => {
        const { calendarSeason } = this.props;

        if (!calendarSeason || !calendarSeason.calendarSeasonDuration) return;

        const formattedEvents = this.formatEvents(calendarSeason.calendarSeasonDuration, calendarSeason);
        const $calendar = $(this.calendarRef.current);

        $calendar.fullCalendar('removeEvents');
        $calendar.fullCalendar('addEventSource', formattedEvents);
    };

    formatEvents = (seasons, calendarSeason) => {
        if (!seasons || !Array.isArray(seasons)) return [];
        const events = [];
        seasons.forEach(season => {
            const duration = season;
            events.push({
                id: duration.id || `${season.id}-${duration.startDate}`,
                title: season.name,
                start: duration.startDate,
                end: moment(duration.endDate).add(1, 'days').format('YYYY-MM-DD'),
                color: calendarSeason.calendarColor,
                rendering: 'background',
            });
        });

        return events;
    };

    render() {
        const { calendarSeason } = this.props;
        const isFetching = calendarSeason ? calendarSeason.isFetching : false;
        const { handleClose, closeDrawer } = this.props;

        return (
            <div style={{ position: 'relative', minHeight: '300px' }}>
                <style>{`
                    /* Remove grey background from past days */
                    .fc-unthemed td.fc-past {
                        background: transparent !important;
                    }
                    /* Make background events less washed out */
                    .fc-bgevent {
                        opacity: 0.6 !important;
                    }
                `}</style>

                {isFetching && (
                    <div
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            zIndex: 10,
                        }}>
                        <CircularProgress />
                    </div>
                )}

                <div ref={this.calendarRef}></div>

                <div className="row">
                    <div className="col-md-12 voffset">
                        <div className="form-group pull-right">
                            <RaisedButton onClick={handleClose} label={'ok'} className="pull-right" primary={true} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CalendarSeasonCalculationCalendarModal;
